module.exports = __webpack_public_path__ + "img/top_up.277de586.svg";